import { ChainID, IBlockchainEntity } from '@ankr.com/chains-list';

import { useChainIcon } from 'uiKit/hooks/useChainIcon';

import { useChainLogoStyles } from './ChainLogoStyles';

export interface ChainLogoProps {
  chain: Pick<IBlockchainEntity, 'id' | 'name'>;
  className?: string;
  size?: number;
}

export const ChainLogo = ({
  chain: { id, name },
  className,
  size,
}: ChainLogoProps) => {
  const { classes, cx } = useChainLogoStyles(size);

  const icon = useChainIcon(id as ChainID);

  if (id === ChainID.ALL_CHAINS || !icon) {
    return null;
  }

  return (
    <img
      alt={`${name} logo`}
      className={cx(
        classes.chainLogo,
        className,
        classes[id as keyof typeof classes],
      )}
      src={icon}
    />
  );
};
